
import { Component, Vue } from "vue-property-decorator";
import { getAPIAuthorizedHeader, EventBus } from "@/services/common";
import Axios from "axios";
import { API_STORE } from "@/config";
import AsyncPageLoader from "@/views/AsyncPageLoader.vue";
import VueNumeric from "vue-numeric";
import NewPageLoader from "@/views/NewPageLoader.vue";
import Modal from "@/views/modal/Modal.vue";
import Swal from "sweetalert2";

@Component({
  components: { AsyncPageLoader, VueNumeric, NewPageLoader, Modal },
})
export default class MobileRechargeComponent extends Vue {
  public rechargeObj = null;
  public operators = [];
  public operatorType = null;
  public selectedOperator = null;
  public submitButtonDisabled = false;
  public newPageLoader = true;
  public showModal = false;
  public modalData = {
    component: null,
    data: null,
    title: null,
  };
  public comAndCharge = "Enter Amount For Commission/Charges";

  public async validateAndRecharge() {
    let valid = await this.$validator.validateAll();
    if (valid) {
      this.submitButtonDisabled = true;
      this.newPageLoader = true;
      this.rechargeObj["performedBy"] = this.$userId;
      this.rechargeObj["operatorName"] = this.selectedOperator.name;
      this.rechargeObj["serviceName"] = "Recharge";
      this.rechargeObj["billPay"] =
        this.checkBillFetchOperator() && this.rechargeObj.transactionAmount == 0
          ? false
          : true;
      let response = await Axios.post(
        API_STORE.SERVICE + "getRecharge",
        this.rechargeObj,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.submitButtonDisabled = false;
      this.newPageLoader = false;
      if (response && response.data) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: true,
        });
        if (this.rechargeObj["billPay"]) {
          EventBus.$emit("refreshWalletAmount", true);
          this.rechargeObj = null;
          this.selectedOperator = null;
        } else {
          this.rechargeObj["transactionAmount"] = response.data.dueAmount;
          this.rechargeObj["customerName"] = response.data.customerName;
        }
      }
    }
  }

  public checkBillFetchOperator() {
    let fetchOperators = ["Utility", "Postpaid"];
    return fetchOperators.includes(this.operatorType);
  }

  public async getApiOperatorCode() {
    this.rechargeObj = null;
    let response = await Axios.get(API_STORE.SERVICE + "getApiOperatorCode", {
      params: {
        apiOperatorCodeId: this.selectedOperator.activeAPIOperatorCodeId,
        subdomain: this.$client ? this.$client.subdomain : null,
      },
      headers: getAPIAuthorizedHeader(),
    });
   if(response) this.rechargeObj = response.data;
  }

  public getValidation(minLen, maxLen) {
    return maxLen && minLen
      ? "required|min:" + minLen + "|max:" + maxLen
      : "required|numeric";
  }

  public async getOperatorList() {
    this.operators = [];
    this.selectedOperator = null;
    this.rechargeObj = null;
    let response = await Axios.get(API_STORE.ADMIN + "getOperatorList", {
      params: {
        operatorType: this.operatorType,
        subdomain: this.$client ? this.$client.subdomain : null,
        apiReference:null
      },
      headers: getAPIAuthorizedHeader(),
    });
    if(response) this.operators = response.data;
  }

  public async showRechargePlans() {
    this.newPageLoader = true;
    if (
      this.rechargeObj.requiredParams[0].value != null &&
      this.rechargeObj.requiredParams[0].value.length == 10
    ) {
      let response = await Axios.get(API_STORE.SERVICE + "showRechargePlans", {
        params: {
          mobileNumber: this.rechargeObj.requiredParams[0].value,
          provider:
            this.selectedOperator.name == "Reliance Jio"
              ? 238
              : this.selectedOperator.name == "Jio"
              ? 238
              : this.selectedOperator.name == "Airtel"
              ? 1
              : this.selectedOperator.name == "BSNL TopUp"
              ? 8
              : 2,
        },
        headers: getAPIAuthorizedHeader(),
      });
      this.newPageLoader = false;
      if(response && response.data){
      this.showModal = true;
      this.modalData.component = "rechargePlan";
      this.modalData.title = "Recharge Offers";
      this.modalData.data = response.data.data.records;
      }
    } else {
      console.log("FALE");
      this.newPageLoader = false;
    }
  }

  public getOfferValue(offerAmount) {
    this.rechargeObj["transactionAmount"] = offerAmount;
    this.getCommissionAndCharges();
  }

  //Get Commssion
  public async getCommissionAndCharges() {
    try {
      let response = await Axios.get(
        API_STORE.SERVICE + "getServiceCommission",
        {
          params: {
            performedBy: this.$userId,
            apiOperatorCodeId: this.selectedOperator.activeAPIOperatorCodeId,
            amount: this.rechargeObj.transactionAmount,
          },
          headers: getAPIAuthorizedHeader(),
        }
      );
      if(response) this.comAndCharge = "₹ " + response.data.netAmount.toString();
    } catch (error) {
      console.log(error);
    }
  }

  //Reset modal
  public resetModalData() {
    this.showModal = false;
    this.modalData.title = null;
    this.modalData.component = null;
    this.modalData.data = null;
  }

  mounted() {
    this.newPageLoader = false;
  }
}
